<template>
  <div>
    <template v-if="editable">
      <div
        v-for="(answer, indexAnswer) in answers"
        :key="answer.id"
      >
        <b-button
          pill
          variant="light"
          :class="'mx-1 btn__exam btn__exam--spell' + ((isSelected === answer.id) ? ' btn__exam--selected' : '')"
          @click="selectAnswer(answer.id)"
        >
          <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
          <span v-html="answer.content"></span>
        </b-button>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(answer, indexAnswer) in answers"
        :key="answer.id"
      >
        <template v-if="answer.is_answer">
          <b-button
            pill
            variant="light"
            :class="'mx-1 btn__exam btn__exam--spell btn__exam--right'"
          >
            <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
            <span v-html="answer.content"></span>
          </b-button>
        </template>
        <template v-else>
          <b-button
            pill
            variant="light"
            :class="'mx-1 btn__exam btn__exam--spell' + ((response.answer_id === answer.id) ? ' btn__exam--exam_no' : '')"
          >
            <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
            <span v-html="answer.content"></span>
          </b-button>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionListeningSpell',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false,
      answers: []
    }
  },
  methods: {
    selectAnswer(a_id) {
      this.isSelected = a_id;

      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer_id: a_id
      })
    }
  },
  mounted() {
    this.question.answers.forEach(answer => {
      const regex = /\{\{(.*?)\}\}/ig;
      const matches = regex.exec(answer.content)

      if (matches) {
        let temp = matches[1].split('|')
        let tempQuestion = temp[0].replace(/ /g, ' ').split(' ')
        let tempAnswer = temp[1].replace(/ /g, ' ').split(' ')
        let tempData = ''

        tempQuestion.forEach((item, index) => {
          tempData += '<span class="mx-1" style="font-size: 14.0pt; line-height: 107%;"><ruby style="ruby-align: center;"><span style="font-family: DengXian;">' + item + '</span><rp>(</rp><rt style="font-size: 11.0pt; font-family: DengXian;">' + tempAnswer[index] + '</rt><rp>)</rp></ruby></span>'
        })

        this.answers.push({
          id: answer.id,
          content: tempData,
          is_answer: answer.is_answer
        })
      } else {
        this.answers.push({
          id: answer.id,
          content: answer.content,
          is_answer: answer.is_answer
        })
      }
    });
  }
}
</script>